import React, { useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { useTranslation } from 'react-i18next';

// icon
import MapIcon from '@material-ui/icons/Map';
import { AlertIcon } from '../../assets/svg/Icon';

// components
import Map from './map/Map';
import TopBarDataLists from './topBar/TopBarDataLists';
import DamLatestProvince from '../dam/lists/latest/DamLatestProvince';
import ToolsDataLists from './tools/ToolsDataLists';
import DamUseWater from './damUseWater/DamUseWater';
import ForecastRainfall from './forecastRainfall/ForecastRainfall';
import WaterLevel from './waterLevel/WaterLevelDataLists';
import RainfallList from './rainfallList/RainfallLists';
import RiskArea from './riskArea/RiskArea';
import RiskAreaProvince from './riskArea/RiskAreaProvince';
import RiskAreaAction from './riskArea/RiskAreaAction';

import { StyledBorderButton } from '../../components/button/Button';

// Provider
import ModeContext from '../../context/ModeContext';

// style
import { globalStyle } from '../../global/style';

const useStyles = makeStyles(globalStyle);

export default function Main() {
  const { t } = useTranslation();
  const classes = useStyles();

  const { handleSelectListClick } = useContext(ModeContext);

  const [error, setError] = useState('');
  const [datasDam, setDatasDam] = useState([]);
  const [datasDamUseWater, setDatasDamUseWater] = useState([]);
  const [datasRiskArea, setDatasRiskArea] = useState([]);
  const [datasRiskAreaId, setDatasRiskAreaId] = useState([]);

  // get current selected area
  const { currentMode, currentArea } = useContext(ModeContext);

  useEffect(() => {
    let listDam = '';

    const fetchData = async () => {
      fetch(`${process.env.REACT_APP_API_URL}/provinces/dam?province_id=${currentArea.code}`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }

          return null;
        })
        .then((result) => {
          if (currentArea.code !== 0) {
            setDatasDam(result.data);

            let listDamDaily = [];
            let listDamDailyNear = [];

            // get all dam ID that related to this area and combine
            // large dam from dam_daily
            // near dam
            // medium dam
            if (result.data.dam_daily) {
              listDamDaily = result.data.dam_daily
                .filter((d) => d.agency.id === 12)
                .map((value) => value.dam.id);
            }

            if (result.data.dam_daily_near) {
              listDamDailyNear = result.data.dam_daily_near
                .filter((d) => d.agency.id === 12)
                .map((value) => value.dam.id);
            }

            // combine all related dam for selected province
            listDam = [...listDamDaily, ...listDamDailyNear].join(',');

            let mediumDamCondition = '';
            if (result.data.dam_medium) {
              // medium dam ไม่มี mapping medium dam near ใช้ medium dam ได้เลย
              const listMediumDamNear = result.data.dam_medium.map((entity) => entity.dam.id).join(',');
              mediumDamCondition = `&mediumdam_id=${listMediumDamNear}`;
            }

            // get dam use water
            fetch(`${process.env.REACT_APP_API_URL}/provinces/dam_uses_water?dam_id=${listDam}${mediumDamCondition}`)
              .then((response) => {
                if (response.ok) {
                  return response.json();
                }
                throw new Error('Something went wrong ...');
              })
              .then((result2) => {
                setDatasDamUseWater(result2.data[0]);
              })
              .catch((error2) => setError({ error2 }));

            // get risk area
            fetch(`${process.env.REACT_APP_BACKOFFICE_API_URL}/api/v1/public/disaster`)
              .then((response) => {
                if (response.ok) {
                  return response.json();
                }
                throw new Error('Something went wrong ...');
              })
              .then((result3) => {
                setDatasRiskArea(result3.data);

                // extract only area id to array
                const riskAreaId = [];
                result3.data.map((d) => {
                  const amphoeCode = d.province_code + d.amphoe_code;
                  riskAreaId.push(amphoeCode);

                  return null;
                });

                setDatasRiskAreaId(riskAreaId);
              })
              .catch((error3) => setError({ error3 }));
          }
        })
        .catch((err) => setError({ err }));
    };

    fetchData();
  }, [currentArea]);

  function handleChangeArea() {
    handleSelectListClick(0);
  }

  if (currentMode === 'basin') {
    return (
      <div>Basin mode is not supproted in this page.</div>
    );
  }

  if (currentMode === 'province' && currentArea.code === '0') {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12}>
          <Box display="flex" alignItems="center">
            <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
              <AlertIcon style={{ color: 'white' }} />
            </Box>
            <Box p={1}><Typography variant="h6" className={classes.titlePage}>{t('พื้นที่ประกาศภัย')}</Typography></Box>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <Map currentArea={currentArea} riskAreasId={datasRiskAreaId} />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <RiskArea datas={datasRiskArea} currentArea={currentArea} />
          <br />
          <RiskAreaAction />
        </Grid>
      </Grid>
    );
  }

  if (currentMode === 'province' && currentArea.code !== '0') {
    return (
      <div className={classes.root}>
        {error && <div>Error Occured</div>}
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={6} sm={6} md={6}>
            <Box display="flex" alignItems="center">
              <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                <AlertIcon style={{ color: 'white' }} />
              </Box>
              <Box p={1}><Typography variant="h6" className={classes.titlePage}>{t('พื้นที่ประกาศภัย')}</Typography></Box>
            </Box>
          </Grid>
          <Grid item xs={6} sm={6} md={6} align="right">
            <StyledBorderButton
              type="button"
              onClick={() => handleChangeArea(0)}
              style={{
                left: 0,
              }}
              startIcon={<MapIcon />}
            >
              {t('ภาพรวมทั้งประเทศ')}
            </StyledBorderButton>
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={3}>
          <Grid item xs sm md>
            <TopBarDataLists currentArea={currentArea} />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} md={3}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <Map currentArea={currentArea} riskAreasId={datasRiskAreaId} />
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <RiskAreaProvince datas={datasRiskArea} currentArea={currentArea} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={8} md={6}>
            <Grid container direction="column" spacing={2}>
              <Grid item xs>
                <DamLatestProvince datas={datasDam} />
              </Grid>
              <Grid item xs>
                <RainfallList />
              </Grid>
              <Grid item>
                <ToolsDataLists />
              </Grid>
            </Grid>
          </Grid>
          <Grid item sm={12} md={3}>
            <Grid container spacing={2}>
              <Grid item sm md={12}>
                <ForecastRainfall
                  currentArea={currentArea}
                />
              </Grid>
              <Grid item sm md={12}>
                <WaterLevel />
              </Grid>
              <Grid item sm md={12}>
                <DamUseWater
                  data={datasDamUseWater}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }

  return null;
}
